export default __webpack_public_path__ + "static/media/fat_burn.7c266059.svg";